// Filter replacements for Vue 3.

export const globalMethods = {
    plural(text, count) {
        return count === 1 ? text : text + 's';
    },
};

export const globalMethodsPlugin = {
    /**
     * @param {Vue} vueApp
     */
    install(vueApp) {
        Object.assign(
            vueApp.config.globalProperties,
            globalMethods
        );
    },
};
